export default "__VITE_ASSET__DGUS1HNn__"